import { render, staticRenderFns } from "./ImageInput.vue?vue&type=template&id=006dbfce&scoped=true&"
import script from "./ImageInput.vue?vue&type=script&lang=js&"
export * from "./ImageInput.vue?vue&type=script&lang=js&"
import style0 from "./ImageInput.vue?vue&type=style&index=0&id=006dbfce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006dbfce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VIcon,VImg})
